module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// /Users/kristinberlehner/sites/recipe-search/wp-content/themes/nutrition-for-me/node_modules/core-js/modules/_a-function.js
// module id = 60
// module chunks = 0